<template>
  <UiContainer tag="section">
    <div v-if="value.description" class="mb-6">
      <UiTitle severity="h3" tag="h2" class="mb-1.5">{{ value.description.title }}</UiTitle>
      <div class="page-content" v-html="value.description.text" />
    </div>
    <FAQQuestion
      v-for="question in value.questions"
      :key="question.title"
      :value="question"
      :open-all="openAll"
    />
  </UiContainer>
</template>

<script lang="ts" setup>
import { UiContainer, UiTitle } from '@/6_shared/ui'
import type { FAQ } from '../model'
import FAQQuestion from './FAQQuestion.vue'

type PropType = {
  value: FAQ
  openAll?: boolean
}

withDefaults(defineProps<PropType>(), {
  openAll: false
})
</script>
